export class ProjectMailingDocumentDTO {
    mailingDocumentId: number;
    projectId: number;
    documentName: string;
    description: string;
    orderedCopies: number;
    receivedCopies: number;
}
